import { Api } from "@/@core";
import { DcmDocumentListQuery, DcmDocumentListStringQuery } from "../interfaces/DcmDocumentListConfiguration";
import { QueryParserService } from "./QueryParserService";

const api = new Api("dcm/repositories/default/");
const heavyApi = new Api("dcm-heavy/repositories/default/");

export class DcmService {
  public static async search(query: DcmDocumentListQuery) {
    const result = await api.get(`search`, {
      q: encodeURI(QueryParserService.queryToString(query)),
      start: query.offset,
      limit: query.limit,
    });
    return result.data;
  }

  public static async querySearch(query: DcmDocumentListStringQuery) {
    const result = await api.get(`search`, {
      q: encodeURI(query.query),
      start: query.offset,
      limit: query.limit,
    });
    return result.data;
  }

  public static async delete(objectId: string) {
    await api.delete(`object/${objectId}`);
  }

  public static async deleteTreeByPath(path: string) {
    await api.delete(`folders`, {
      folderPath: path,
      deleteTree: true,
    });
  }

  public static async getObjectContentAsBlob(fullObjectId: string, uniqueDownload: boolean) {
    const objectId = fullObjectId.split(";")[0];
    const result = await heavyApi.get(
      `objects/${objectId}/content/stream`,
      { uniqueDownload },
      {},
      { responseType: "blob" }
    );
    return result.data;
  }

  /*public static async createDocument(document: FileRepresentation, path: string) {
    const result = await api.post(
      `folders/documents`,
      document,
      {},
      { folderPath: path }
    );
    return result.data;
  }*/

  public static async createDocument(
    file: File,
    properties: { [key: string]: any },
    folderPath: string,
    overwrite?: boolean
  ) {
    const formData = new FormData();
    formData.append("properties", JSON.stringify(properties));
    formData.append("file", file);
    return (
      await heavyApi.post(
        `folders/documents`,
        formData,
        {},
        { overwrite: !!overwrite, folderPath: encodeURI(folderPath) }
      )
    ).data;
  }

  // doesn't work ?
  public static async updateDocument(documentId: string, file: File, properties: { [key: string]: any }) {
    const formData = new FormData();
    formData.append("properties", JSON.stringify(properties));
    formData.append("file", file);
    return (await heavyApi.put(`folders/documents/${documentId}`, formData, {})).data;
  }

  public static async updateProperties(objectId: string, properties: any) {
    const formData = new FormData();
    formData.append("properties", JSON.stringify(properties));
    await api.put(`objects/${objectId}`, properties);
  }
}
